<template>
  <el-row class="mt-5 mb-3 history-page">
    <el-col align="center">
      <h1 class="green-title"><strong>Nossa História</strong></h1>
      </el-col>
  </el-row>

  <el-row class="mt-5 mb-3" justify="center">
    <el-col  align="center" :span="20">
      <liteYouTubeEmbed
        id="YcOnegmqRAQ"
        title="Pixeon - Nossa História"
      />
    </el-col>
  </el-row>

  <el-row justify="center" align="center" class="mt-5 mb-5">
    <el-col :span="20" justify="center" align="center" class="history-action bg-green pb-3 pt-3">
      <p>Saiba como tudo começou</p>
      <el-button round @click="openDescription = !openDescription">Leia nossa história</el-button>
    </el-col>
  </el-row>

  <el-row class="description mt-5" v-if="openDescription" justify="center">
    <el-col :span="18" align="center">
      <figure>
        <img
          class="logo mb-5"
          alt="Vue logo"
          src="https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/history%2Flogo%2Flogo%20pixeon.png?alt=media&token=7674df30-f5d3-4efa-8cb9-c3eb6e98430a"
        />
      </figure>
      <div class="pt-3" v-html="data.text"></div>
      <el-row class="timeline pt-5">
        <el-col align="center">
          <figure>
            <img
              class="icon"
              alt="Vue logo"
              :src="data.img1"
            />
          </figure>
        </el-col>
      </el-row>
      <div class="" v-html="data.text2"></div>

      <div class="close-btn-text" @click="openDescription = false">
        Fechar
      </div>
    </el-col>
  </el-row>

  <el-row class="timeline mt-5">
    <el-col align="center">
      <figure>
        <img
          class="icon mb-5"
          alt="Vue logo"
          :src="data.img2"
        />
      </figure>
    </el-col>
  </el-row>
</template>

<script>
import { ref } from 'vue'
import axios from 'axios'
import { firebaseRoutes } from '../../config/firebase.conf'
import LiteYouTubeEmbed from 'vue-lite-youtube-embed'
import 'vue-lite-youtube-embed/dist/style.css'
export default {
  name: 'History',
  components: {
    LiteYouTubeEmbed
  },
  async setup () {
    const data = ref('')
    data.value = await axios.get(firebaseRoutes.historia).then((response) => {
      const result = []
      for (const id in response.data) {
        result.push({
          id: id,
          text: response.data[id].text,
          text2: response.data[id].text2,
          img1: response.data[id].img1,
          img2: response.data[id].img2
        })
      }
      return result[0]
    })

    const openDescription = ref(false)

    return {
      data,
      openDescription
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
.green-title {
  color: $green;
  font-weight: bold;
  text-transform: uppercase;
}

.logo {
  height: 10rem;
}

.icon {
  width: 100%;
}

.holders {
  width: 80%;
}

.history {
  cursor: pointer;
}

.timeline {
  img {
    margin-bottom: 2rem;
  }
}

.history-action {
  width: 100%;
  margin-top: 2rem;

  p {
    font-size: 2rem;
    color: $white;
    text-transform: uppercase;
    font-weight: bold;
  }
}
</style>
